var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import useThemeMode from "../../hooks/useThemeMode.js";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect.js";
var ThemeContext = React.createContext(null);
export var useTheme = function () { return React.useContext(ThemeContext); };
var ThemeProvider = function (props) {
    var theme = props.theme, children = props.children;
    var lightDefinition = theme.lightDefinition, darkDefinition = theme.darkDefinition, lightAttributes = theme.lightAttributes, darkAttributes = theme.darkAttributes;
    var mode = useThemeMode().mode;
    var parentTheme = useTheme();
    var hasParentTheme = !!parentTheme;
    var themeDefinition = mode === "dark" ? darkDefinition : lightDefinition;
    var themeAttributes = mode === "dark" ? darkAttributes : lightAttributes;
    var themeNode = parentTheme ? (React.createElement("div", __assign({}, themeAttributes), children)) : (children);
    useIsomorphicLayoutEffect(function () {
        if (hasParentTheme)
            return;
        Object.keys(themeAttributes).forEach(function (key) {
            // Avoid theme provider overriding the already defined theme
            if (document.body.hasAttribute(key))
                return;
            document.body.setAttribute(key, themeAttributes[key]);
        });
        return function () {
            Object.keys(themeAttributes).forEach(function (key) {
                document.body.removeAttribute(key);
            });
        };
    }, [themeAttributes["data-bui-theme"], hasParentTheme]);
    return (React.createElement(ThemeContext.Provider, { value: themeDefinition }, themeNode));
};
export default ThemeProvider;
